<template>
  <MgdAlert v-if="!!message" variant="warning">
    <Icon name="lucide:triangle-alert" />
    <MgdAlertDescription class="flex flex-wrap items-center">
      {{ message }}
    </MgdAlertDescription>
  </MgdAlert>
</template>

<script setup lang="ts">
const message = useStringFeatureFlag("ops_global_warning_message");
</script>
